import type { Ranges } from 'api/System/types'
import { getDateKey } from 'data/utils'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import { FETCH_COUNTRIES, FETCH_COUNTRIES_DONE, FETCH_COUNTRIES_ERROR, FETCH_COUNTRIES_SUCCESS } from './constants'
import type { Countries, CountryResponse } from './types'

interface ReducerAction extends Action {
  payload: {
    channel: string
    countries?: boolean
    countryId?: string
    data: CountryResponse[]
    dateCompared?: RequestDate | null
    dateCurrent: RequestDate
    errorCode?: number
    owner?: string
    range: Ranges
    saleType?: string
  }
}

export default function countries(state: Countries = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_COUNTRIES:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          errorCode: null,
          isLoading: true,
        },
      }
    case FETCH_COUNTRIES_DONE:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_COUNTRIES_ERROR:
      return {
        ...state,
        [getDateKey(payload)]: {
          errorCode: payload?.errorCode,
          isLoading: false,
        },
      }
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          data: payload.data,
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    default:
      return state
  }
}
